import ProfileHeroEdit from './ProfileHeroEdit';
import ProfileHeroEditContainer from './ProfileHeroEdit.container';

export default ProfileHeroEditContainer(ProfileHeroEdit);
